export default __webpack_public_path__ + "static/media/phone.0f0310d7.svg";